// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"4fd53579","494":"34a2d3b5"}[chunkId] + ".chunk.css";
};